import { apiRequest, apiImageRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * get cover photo
 * @param data
 * @returns {Promise}
 */
const getCover = url => {
  if (!url.startsWith('/api')) {
    url = '/api' + url;
  }
  return new Promise((resolve, reject) => {
    apiImageRequest(url, 'image/jpeg')
      .then(response => {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 * check cover path usage
 * @param data
 * @returns {Promise}
 */
const checkCoverUsage = path => {
  return new Promise((resolve, reject) => {
    let url = '/api/cover/check' + path;

    apiRequest(url, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};
export { getCover, checkCoverUsage };
